import {createFeatureSelector, createSelector, MemoizedSelector} from '@ngrx/store';
import {DATASET_METRICS_GROUPS_STATE_NAME, DataSetMetricsGroupsState} from './dataSetMetricsGroups';
import {Serializers} from '../../interfaces/serializer';
import {DataSetMetricsGroup} from '../../interfaces/metrics';
import {DatasetMetricsGroupComponentObjects} from '../../classes/dataset-metrics-group-component-object';

export const selectDataSetMetricsGroupsState: MemoizedSelector<object, DataSetMetricsGroupsState> = createFeatureSelector<DataSetMetricsGroupsState>(DATASET_METRICS_GROUPS_STATE_NAME);

export const selectDataSetMetricsGroups: MemoizedSelector<object, Serializers<DataSetMetricsGroup>> = createSelector(
  selectDataSetMetricsGroupsState,
  (state: DataSetMetricsGroupsState): Serializers<DataSetMetricsGroup> => state.serialized
);

export const selectDataSetMetricsGroupComponentObjects: MemoizedSelector<object, DatasetMetricsGroupComponentObjects> = createSelector(
  selectDataSetMetricsGroupsState,
  (state: DataSetMetricsGroupsState): DatasetMetricsGroupComponentObjects => state.componentObjects
);

export const selectDataSetMetricsGroupsLoading: MemoizedSelector<object, boolean> = createSelector(
  selectDataSetMetricsGroupsState,
  (state: DataSetMetricsGroupsState): boolean => state.loading
);

export const selectDataSetMetricsGroupsLoaded: MemoizedSelector<object, boolean> = createSelector(
  selectDataSetMetricsGroupsState,
  (state: DataSetMetricsGroupsState): boolean => state.loaded
);

export const selectDataSetMetricsGroupsInitialized: MemoizedSelector<object, boolean> = createSelector(
  selectDataSetMetricsGroupsState,
  (state: DataSetMetricsGroupsState): boolean => state.initialized
);
